import { useMemo } from 'react';
import { useWebsiteStattistic } from '..';

const useTopProduct = () => {
  const { data } = useWebsiteStattistic();

  const topProduct = useMemo(() => {
    if (Array.isArray(data?.top_product)) {
      return data.top_product;
    }

    return [];
  }, [data?.top_product]);

  const columns = useMemo(() => {
    return [
      {
        title: 'Tên',
        render: (_, record) => record?.product?.name,
      },
      {
        title: 'Lượt xem',
        render: (_, record) => record?.count,
      },
    ];
  }, []);

  return {
    columns,
    dataSource: topProduct,
  };
};

export default useTopProduct;
